/**
 * Resolve the backend API base URL.
 *
 * - In Vite (dev/build): `import.meta.env.VITE_API_URL` is inlined at build
 *   time. The reference appears below in module top-level code so the
 *   substitution kicks in.
 * - In Jest (CJS, @swc/jest): this module is replaced via the
 *   `moduleNameMapper` rule in `jest.config.cjs` so the `import.meta` token
 *   never reaches the parser. Tests can override the value via
 *   `(globalThis as { __FOUNDRY_API_BASE__?: string }).__FOUNDRY_API_BASE__`.
 */

const FALLBACK = 'http://localhost:3050';

const env = (import.meta as { env?: Record<string, string | undefined> }).env;
const trimmed = env?.['VITE_API_URL']?.trim();
const RESOLVED = trimmed && trimmed.length > 0 ? trimmed : FALLBACK;

export function getApiBaseUrl(): string {
  const override = (globalThis as { __FOUNDRY_API_BASE__?: string }).__FOUNDRY_API_BASE__;
  return override ?? RESOLVED;
}
